












import {
  Component, Vue, Prop, Watch, Model,
} from 'vue-property-decorator';
import { BFormFile } from 'bootstrap-vue';

@Component
export default class FileInput extends Vue {
  $refs!: {
    fileInput: InstanceType<typeof BFormFile>;
  }

  @Model('change', { type: [Array, File] })
  readonly value!: File | File[] | null;

  @Prop({
    type: String,
    default: '拖拉圖片到此區域上傳',
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: '拖拉圖片到此區域上傳',
  })
  dropPlaceholder!: string;

  @Prop({
    type: String,
    default: '選擇圖片',
  })
  browseText!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  multiple!: boolean;

  @Prop({
    type: String,
    default: '',
  })
  accept!: string;

  localFiles: File | File[] | null = null;

  @Watch('value')
  onValueChanged() {
    this.localFiles = this.value;
  }

  @Watch('localFiles')
  onFilesChanged() {
    console.log('localFiles');
    this.$emit('change', this.localFiles);
    this.$emit('input');
    this.$emit('files-changed', this.multiple ? this.localFiles : [this.localFiles]);
  }

  reset() {
    this.$refs.fileInput.reset();
  }
}
